import CompanyWifiTab from 'src/components/pages/Company/CompanyPage/CompanyWifiTab/CompanyWifiTab';

export default CompanyWifiTab;
